// @ts-check
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React from 'react';
import activateLocale from './activateLocale';

/**
 * Provides the user's locale.
 * Requires ApolloProvider for querying the user.
 * @param {object} props
 * @param {string} props.locale
 * @param {object} props.messages
 * @param {React.ReactNode} props.children
 */

export default function UserLocaleProvider({
  locale = 'en',
  messages,
  children,
}) {
  activateLocale(locale, messages);
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
